import { render, staticRenderFns } from "./TableOffer.vue?vue&type=template&id=00e1c3c6&"
import script from "./TableOffer.vue?vue&type=script&lang=js&"
export * from "./TableOffer.vue?vue&type=script&lang=js&"
import style0 from "./TableOffer.vue?vue&type=style&index=0&id=00e1c3c6&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('00e1c3c6')) {
      api.createRecord('00e1c3c6', component.options)
    } else {
      api.reload('00e1c3c6', component.options)
    }
    module.hot.accept("./TableOffer.vue?vue&type=template&id=00e1c3c6&", function () {
      api.rerender('00e1c3c6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Offers/TableOffer.vue"
export default component.exports